const normalizeId = (value) => String(value || '').trim().toLowerCase();

export const getAgentPropertyIds = (agent) => {
  if (!agent) return [];
  return [agent.id, agent.adminId].filter(Boolean).map(normalizeId);
};

export const getAgentProperties = (properties, agent) => {
  if (!agent || !Array.isArray(properties)) return [];

  const agentIds = getAgentPropertyIds(agent);
  if (agentIds.length === 0) return [];

  return properties.filter((property) => {
    if (!property?.agentId) return false;
    return agentIds.includes(normalizeId(property.agentId));
  });
};

export const getAgentPropertyCount = (properties, agent) =>
  getAgentProperties(properties, agent).length;

export const getPropertiesForAgentUser = (properties, user) => {
  if (!user || user.username === 'admin') {
    return Array.isArray(properties) ? properties : [];
  }

  return getAgentProperties(properties, {
    id: user.agentId,
    adminId: user.id,
  });
};

export const propertyBelongsToAgentUser = (user, property) => {
  if (!user || user.username === 'admin') return true;
  return getAgentProperties([property], { id: user.agentId, adminId: user.id }).length > 0;
};

export const generateUsernameFromName = (name) => {
  const firstName = String(name || '').trim().split(/\s+/)[0] || '';
  return firstName.toLowerCase().replace(/[^a-z0-9]/g, '');
};
